import { FunctionComponent } from 'react';
import { Outlet } from 'react-router';
import { UserRole } from 'softcat:config/user-role.ts';
import { useAuth } from 'softcat:hooks/use-auth.ts';
import { NotFound } from 'softcat:routes/not-found.tsx';

type ProtectedRouteProperties = {
    role: UserRole;
};

export const ProtectedRoute: FunctionComponent<ProtectedRouteProperties> = ({ role }) => {
    const { hasRequiredRole } = useAuth();

    if (!hasRequiredRole(role)) {
        return <NotFound />;
    }

    return <Outlet />;
};
